const getEnvItem = (name, type, defaultValue = null) => {
  switch (type) {
    case 'boolean':
      return process.env[name] !== undefined ? process.env[name] === 'true' : defaultValue;
    case 'string':
    default:
      return process.env[name] !== undefined ? process.env[name] : defaultValue;
  }
};

export default getEnvItem;
